/*
 * サブシステム名：設定その他
 * 機能名：データ取込
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdDateBox from '@/components/DdDateBox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFileInput from '@/components/DdFileInput'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import header from '@/ddv2.library/header'

export default {
  name: 'DataImportList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      riyoKikanYmdFrom: '',
      riyoKikanYmdTo: '',
      eigyoshoId: '',
      sharyoId: ''
    },
    modeKengen: 0,
    // オートコンプリート用ヘッダー
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders
  }),
  components: {
    DdSubHeader,
    DdDateBox,
    DdCodeTextBox,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFileInput,
    DdFooterButton,
    DdDataTable
  },
  computed: {
    ...mapGetters({
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo'
    }),
    // 営業所マスタフィルター --> ここから
    filteredMstEigyosho () {
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstEigyosho.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 車輛マスタフィルター --> ここから
    filteredMstSharyo () {
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // ※傭車は除く
    filteredMstSharyoList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstSharyo.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === false
      })
    },
    // 車輛マスタフィルター <-- ここまで
    isValidImportButton () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    filteredRows () {
      return this.rows.map((elem) => {
        elem.importStartDisp = elem.importStart ? dayjs(elem.importStart).format('YYYY/MM/DD HH:mm:ss') : ''
        elem.importEndDisp = elem.importEnd ? dayjs(elem.importEnd).format('YYYY/MM/DD HH:mm:ss') : ''
        return elem
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['vwcmsteigyoshojininlist', 'vwcmstsharyo'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: 'No', value: 'renNo', align: 'center' },
              { text: '状態', value: 'status', align: 'center' },
              { text: '車輛番号', value: 'etcSharyoNo' },
              { text: '利用日時（自）', value: 'riyoJiYmdHms' },
              { text: '利用IC（自）', value: 'riyoJiIc' },
              { text: '利用日時（至）', value: 'riyoItaYmdHms' },
              { text: '利用IC（至）', value: 'riyoItaIc' },
              { text: '割引前料金', value: 'etcWaribikiMaeRyokin' },
              { text: 'ETC割引額', value: 'etcWaribikiKingaku' },
              { text: '通行料金', value: 'etcTsukoRyokin' },
              { text: '還元額適用料金', value: 'etcKangenTekiyoRyokin' },
              { text: '前払金適用料金', value: 'etcMaebaraiTekiyoRyokin' },
              { text: '後納料金', value: 'etcGonoRyokin' },
              { text: '車種', value: 'etcSharyoSbt' },
              { text: 'カード番号', value: 'creditCardNo' },
              { text: '備考', value: 'etcBiko' },
              { text: '営業所', value: 'eigyosho' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              maker: '',
              file: '',
              filePath: '',
              fileName: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    clear: function () {
      console.log('clear pushed')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              maker: '',
              file: '',
              filePath: '',
              fileName: ''
            }
            this.searchText = ''
            this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onSearchButtonClick: function (e) {

    },
    onTorikomiButtonClick: function (e) {
      console.log('cklick')
      if (this.validateAll(this.$refs)) {
        this.Effects.loadStart()
        console.log('Torikomi start', e)
        this.HttpClient.post('/api/v1/D2PRMD0800/Exec', this.conditions)
          .then((data) => {
            if (data.isValid) {
              console.log('retdata', data)
              this.transition(0, { id: data.payload, edit: 1 })
            } else {
              this.setSummaryMessage(data.summaryMessage)
              this.Effects.loadComplete()
            }
          }).catch((e) => {
            console.log('error', e)
            this.setSummaryMessage(e.message)
            this.Effects.loadComplete()
          })
      }
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onDeleteButtonClick: function (e) {

    },
    onCancelButtonClick: function (e) {

    },
    onCsvButtonClick: function (e) {

    },
    onPdfButtonClick: function (e) {

    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id, edit: 0 })
    },
    searchValidate: function () {
      return true
    },
    storeFileInfo: function (file) {
      console.log('file selected', file)

      if (file === undefined || file === null) {
        this.conditions.fileData = ''
        this.conditions.fileName = ''
        return
      }
      this.conditions.fileName = file.name

      const fr = new FileReader()
      fr.readAsDataURL(file)
      fr.addEventListener('load', () => {
        this.conditions.fileData = fr.result
      })
      console.log('file selected e')
    }
  }
}
